import React from "react";
import PropTypes from "prop-types";

import "styles/kan-ban-container.css";

class KanBanContainer extends React.Component {
    render() {
        return (
            <div className={"kan-ban-container"}>
                <div className={"kan-ban-inner-container"}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

KanBanContainer.propTypes = {
    children: PropTypes.any
};

export default KanBanContainer;
